<template>
	<v-card class="link-accounts" elevation="0">
			<a :href="'/#/money?add=true'">
			<v-img :src="require('@/assets/bg/VouchersLinkAccounts.png')"  position="top"/>
			<div class="text-panel">
				<h4 class="header">Link accounts to get tailored highlights for you</h4>
				<p class="description">We can show you personalised discounts based on your spending.</p>
			</div>
		</a>
	</v-card>
</template>

<script setup lang="ts">
</script>

<style scoped>
.link-accounts {
	border-radius: 12px;
	overflow: hidden;
}

.text-panel {
	background: #E8E3E2;
	padding: 20px;
	color: #413655;
}

.text-panel p {
	margin: 0;
	font-size: 14px;
	line-height: 1.4;
}

.header {
	margin: 0;
	font-size: 16px;
	margin-bottom: 8px;
}

.description {
	margin: 0;
	font-size: 14px;
}

/* Mobile dark mode */
:root.mobile-dark-mode .text-panel {
	background: var(--background-color);
	color: var(--text-color);
}

</style>